// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import getValuesToBreakpoint from "@toolkit/Framework/Common/Utilities/getValuesToBreakpoint";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface BaseGridProps {
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumn?: GridItemProps;
}

export const baseGridProps: BaseGridProps = {
    container: {
        gap: 0,
        css: css`
            ${({ theme }) => {
                return gridGapStyles(
                    pxToRemArray([30, null, 35, 40, 45]),
                    getValuesToBreakpoint(theme.design.layout.spacing.content, "sm", theme),
                );
            }}
        `,
    },
    sideColumn: {
        width: [12, 12, 4, 3, 3],
        css: css`
            display: block;
        `,
    },
    mainColumn: {
        width: [12, 12, 8, 9, 9],
        css: css`
            display: block;
        `,
    },
};

export const baseGridHiddenProps: BaseGridProps = {
    container: baseGridProps.container,
    sideColumn: {
        ...baseGridProps.sideColumn,
        width: [0, 0, 4, 3, 3],
    },
    mainColumn: baseGridProps.mainColumn,
};
